import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { colorBgPrimaryLight, colorTextMedium, colorBgBase, space1, space2, space4, space5, space6, space8, space12 } =
    theme();

  return StyleSheet.create({
    backToTopButtonContainerPosition: {
      bottom: space4,
      right: space4,
    },
    bottomMessage: {
      marginBottom: space8,
      marginTop: space8,
    },
    centeredContainer: {
      alignItems: "center",
      justifyContent: "center",
    },
    container: {
      flexDirection: "column",
      flexGrow: 1,
      width: "100%",
    },
    crossSellingBanner: {
      flex: 1,
    },
    footer: {
      bottom: space4,
      right: space4,
    },
    looksWrapper: {
      justifyContent: "center",
    },
    looksWrapperDesktop: {
      alignItems: "center",
      marginBottom: space8,
    },
    looksWrapperMobile: {
      padding: space4,
    },
    mainContentContainer: {
      backgroundColor: colorBgPrimaryLight,
    },
    subtitle: {
      color: colorTextMedium,
    },
    subtitleDesktop: {
      textAlign: "center",
    },
    titleDesktop: {
      marginBottom: space2,
      textAlign: "center",
    },
    titleMobile: {
      marginBottom: space1,
    },
    titleWrapper: {
      marginBottom: space1,
      width: "100%",
    },
    titleWrapperDesktop: {
      paddingVertical: space12,
    },
    titleWrapperMobile: {
      backgroundColor: colorBgBase,
      paddingHorizontal: space6,
      paddingVertical: space5,
    },
  });
};

export { style };
